import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Botón "volver" unificado para toda la plataforma.
 * - `to`: ruta destino (string). Si se omite, retrocede en el historial (-1).
 * - `label`: texto a mostrar. Por defecto usa common.back ("Volver").
 * Estilo e ícono consistentes en cliente, proveedor y admin.
 */
export default function BackButton({ to, label, className = '' }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (to) navigate(to);
    else navigate(-1);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`mb-6 inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-[#134168] transition-colors min-h-[44px] active:opacity-75 ${className}`}
    >
      <ArrowLeft className="w-4 h-4" />
      {label || t('common.back', 'Volver')}
    </button>
  );
}
